/**
 * Shared touch/pointer thresholds used by every viewer gesture so there's
 * never a "dead zone" where neither a tap NOR a drag is recognised.
 *
 * The brief (iter28 P0 stabilization): "Use one shared threshold config
 * for tap vs drag. Do not leave a gap."
 *
 *   movement <= TAP_MAX_PX  → treat as a tap (activates zone, button, etc.)
 *   movement >  TAP_MAX_PX  → treat as the start of a drag (engages scrub
 *                             / scene gesture, never the zone tap)
 *
 * Both `ZoneLayer` and `PublicViewer`'s gesture handler import these so
 * there is exactly one source of truth.
 */
export const TAP_MAX_PX = 10;
/** Drag is engaged as soon as movement exceeds the tap threshold. */
export const DRAG_START_PX = TAP_MAX_PX + 0.0001;

/** Convenience: is this delta a tap (no drag)? */
export function isTapDelta(dx, dy) {
  return Math.max(Math.abs(dx), Math.abs(dy)) <= TAP_MAX_PX;
}
